import { useMutation, useQuery } from '@apollo/client'
import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import LayoutTable from '../../../Global/LayoutTable'
import ContentHeader from '../../../Layout/ContentHeader'
import { GET_ALL_WATER_TRUCKS } from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequest'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { AuthContext } from '../../../../Auth/AuthContext'
import moment from 'moment'
import { CREATE_WATER_TRUCK_REQUEST_CONCILIATION } from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequestConciliations'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'

const CreateConciliationModal = ({
  date_conciliation_start,
  date_conciliation_end,
  conciliationsIds,
  refModal,
  refetch,
}) => {
  if (
    !date_conciliation_start ||
    !date_conciliation_end ||
    !conciliationsIds ||
    conciliationsIds.length === 0
  ) {
    throw new Error(
      'La fecha de inicio y fin de la conciliación son requeridas'
    )
  }
  const { user } = useContext(AuthContext)

  //------- STATES:
  const { showLoading, hideLoading } = useLoading()

  const [dataTable, setDataTable] = useState({
    data: [],
    total: 0,
  })

  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    filters: {
      status_id: 22, //Completed
      nameColumnDateType: 'completed_at',
      dateFrom: date_conciliation_start,
      dateTo: date_conciliation_end,
      provider_id: user.provider_id,
      conciliationsConditions: true,
      ids: conciliationsIds,
    },
  })

  const {
    loading,
    error,
    data,
    refetch: refetchWaterTrucks,
  } = useQuery(GET_ALL_WATER_TRUCKS, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      searchQuery: pagePagination.searchQuery,
      filters: pagePagination.filters,
    },
    fetchPolicy: 'no-cache',
  })

  const [CreateConciliation] = useMutation(
    CREATE_WATER_TRUCK_REQUEST_CONCILIATION
  )

  useEffect(() => {
    try {
      if (loading) return
      if (error)
        return toastSweetAlert({ mode: 'error', message: error.message })

      const { getAllWaterTruckRequests } = data

      const list = getAllWaterTruckRequests.rows.map((item) => ({
        id: item.id,
        Folio: item.folio,
        Volumen: item.volume,
        'Fecha de creación': item?.createdAt ? moment(item.createdAt).format('DD-MM-YYYY') : 'Sin fecha',
        'Fecha de finalización': item?.completed_at
          ? moment(item.completed_at).format('DD-MM-YYYY')
          : 'Sin fecha',
        // prioridad: item.priority,
        Tipo: item.type_delivery,
        'Placa Camion':
          item?.RoutesOfWaterTruckRequest?.RouteToTrucks?.plate_number,
        // provedor: item.ProviderOfWaterTruckRequest?.card_name,
        Estatus: (
          <>
            <ProgressBarStatusReport
              statusReport={item.StatusOfWaterTruckRequest}
            />
          </>
        ),
      }))

      setDataTable({
        data: list,
        total: getAllWaterTruckRequests.count,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [
    data,
    error,
    loading,
    conciliationsIds,
    date_conciliation_start,
    date_conciliation_end,
  ])

  //------- Functions:
  const handleCreateConciliation = async () => {
    showLoading()
    try {
      await CreateConciliation({
        variables: {
          conciliationsIds: conciliationsIds,
          dateConciliationEnd: date_conciliation_end,
          dateConciliationStart: date_conciliation_start,
        },
      }).then(() => {
        refetchWaterTrucks()
        refetch()
        hideLoading()
        setPagePagination({
          ...pagePagination,
          filters: {
            ...pagePagination.filters,
            ids: [],
            dateFrom: null,
            dateTo: null,
          },
        })
        toastSweetAlert({
          mode: 'okToast',
          message: 'Conciliación creada correctamente',
        })
        refModal.current.click()
      })
    } catch (error) {
      hideLoading()
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  return (
    <>
      <LayoutTable
        hideId
        hideActions
        hideAddNew
        exportImportButton={false}
        title="Pipas disponibles"
        data={dataTable.data}
        totalCount={dataTable.total}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        refetchFunctionQueries={refetch}
        requery={GET_ALL_WATER_TRUCKS}
        hideFilterBar
        // FilterBarPlaceholder="Buscar por folio"
        showAddNewButton
        handleAddNewButton={handleCreateConciliation}
        handleAddNewButtonTxt="Crear conciliación"
      />
    </>
  )
}

CreateConciliationModal.propTypes = {
  date_conciliation_start: PropTypes.string.isRequired,
  date_conciliation_end: PropTypes.string.isRequired,
  conciliationsIds: PropTypes.array.isRequired,
  refetch: PropTypes.func.isRequired,
  refModal: PropTypes.object.isRequired,
}

export default CreateConciliationModal
